import type { CanvasArtifactSummary } from './shared';

/** Load every page before client-side search and counts are presented. */
export async function loadCanvasLibrary(
  projectId: string,
  token: string,
  signal: AbortSignal,
  request: typeof fetch = fetch
): Promise<{ assets: CanvasArtifactSummary[]; available: boolean }> {
  const assets = new Map<string, CanvasArtifactSummary>();
  const cursors = new Set<string>();
  let cursor: string | null = null;
  do {
    signal.throwIfAborted();
    const query = new URLSearchParams({ projectId, paginate: 'true' });
    if (cursor) query.set('cursor', cursor);
    const response = await request(`/api/canvas?${query}`, {
      headers: { Authorization: `Bearer ${token}` },
      signal,
    });
    signal.throwIfAborted();
    if (response.status === 404) return { assets: [], available: false };
    const payload = await response.json();
    if (!response.ok) throw new Error(payload?.error || 'Couldn’t load assets.');
    if (!Array.isArray(payload?.canvases)) throw new Error('Couldn’t load assets.');
    for (const asset of payload.canvases) assets.set(asset.id, asset);
    cursor = payload.nextCursor || null;
    if (cursor && cursors.has(cursor)) throw new Error('Couldn’t load all assets. Please retry.');
    if (cursor) cursors.add(cursor);
  } while (cursor);
  signal.throwIfAborted();
  return { assets: [...assets.values()], available: true };
}
